import React, { useState, useContext } from 'react';
// import { FaArrowLeftLong } from 'react-icons/fa6';
import {  useNavigate } from 'react-router-dom';
import { FormContext } from './Provider';
// import { form } from 'framer-motion/client';

const TermsAndCondition = ({ step, setStep }) => {

    const navigate = useNavigate();

    const { formData, academicInfo, registerinfo, employmentData, setemploymentData, setRegisterInfo, setAcademicInfo, setFormData } = useContext(FormContext);

    const [termsAccepted, setTermsAccepted] = useState(false);

    const api = process.env.REACT_APP_URL;

    // Function to handle form submission


    const SubmitData = () => {

        const formDatas = new FormData();
        // Personal Information Details
        formDatas.append('name', formData.fullName);
        formDatas.append('dob', formData.dob);
        formDatas.append('guardianName', formData.parentName);
        formDatas.append('gender', formData.gender);
        formDatas.append('address', formData.address);
        formDatas.append('contact', formData.contactno);
        formDatas.append('alternateNumber', formData.alternateNumber);
        formDatas.append('email', formData.email);
        formDatas.append('pincode', formData.pincode);
        formDatas.append('emergencyContact', formData.emergency);
        formDatas.append('proof', formData.proofOfIdentity);
        formDatas.append('proofImage', formData.image);
        formDatas.append('profilePic', formData.profilePic)

        // Academic Information Details
        formDatas.append('instituteName', academicInfo.instituteName);
        formDatas.append('courseName', academicInfo.courseName);
        formDatas.append('deptName', academicInfo.deptName);
        formDatas.append('isGoing', academicInfo.isGoing);
        formDatas.append('passout', academicInfo.passout);
        formDatas.append('location', academicInfo.location);

        // Employment Information Details
        formDatas.append('companyName', employmentData.company);
        formDatas.append('designation', employmentData.designation);
        formDatas.append('exp', employmentData.experience);
        formDatas.append('companyLocation', employmentData.location);
        formDatas.append('JoinedDate', employmentData.joineddate);
        formDatas.append('EndDate', employmentData.enddate);
        formDatas.append('isactive', employmentData.currentlyWorking);

        // Register Information Details
        formDatas.append('registerDate', registerinfo.registrationDate);
        formDatas.append('course', registerinfo.courseName);
        formDatas.append('batchStart', registerinfo.batchStartDate);
        formDatas.append('batchEnd', registerinfo.batchEndDate);
        formDatas.append('type', registerinfo.hearAboutUs);
        formDatas.append('extraInfo', registerinfo.reasons);
        formDatas.append('feeMethod', registerinfo.feeMethod);
        formDatas.append('signature', registerinfo.uploadFile);


        fetch(`${api}/create-studentDetails`, {
            method: 'POST',
            credentials: 'include',
            body: formDatas,

        })
            .then(res => res.json())
            .then(data => {

                if (data.success === true) {
                    alert("Registration Successful");
                    resetsData()
                    navigate('/');

                }
                else {
                    alert(data.message);
                }
            })
            .catch(err => {
                console.log("error in fetch user register", err);
                alert("Trouble in Registration, Please try again later");
            })
    }

    // For resets all data 
    const resetsData = () => {
        const today = new Date().toISOString().split('T')[0];
        setFormData({
            fullName: '',
            dob: '',
            parentName: '',
            gender: '',
            address: '',
            contactno: '',
            alternateNumber: '',
            email: '',
            pincode: '',
            emergency: '',
            proofOfIdentity: '',
            image: null,
            imagePreview: ''
        })

        setAcademicInfo({
            instituteName: "",
            courseName: "",
            deptName: "",
            passout: "",
            location: ""
        })

        setemploymentData({
            company: "",
            designation: "",
            experience: "",
            location: "",
            joineddate: "",
            enddate: "",
            currentlyWorking: false,
        })

        setRegisterInfo({
            registrationDate: today,
            courseName: "",
            batchStartDate: "",
            batchEndDate: "",
            hearAboutUs: "",
            reasons: "",
            feeMethod: "",
            uploadFile: null,
            imagePreviews: ''
        })
    }

    return (
        <div className="bg-white  p-7">
            <div className="flex justify-center items-start  bg-gray-100 px-2 py-10">
                <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                    <div className="font-bold text-lg text-primary-800 ">Terms & Conditions</div>
                    <div className="pt-2 text-gray-700 ">
                        Please review and accept the terms and conditions
                    </div>

                    {/* Terms List */}
                    <div className=" mt-6 p-6 rounded-md leading-loose">
                        <ol className="list-decimal pl-6 space-y-4 ">
                            1. Students must follow the batch time without fail.<br></br>
                            2. Students must attend all classes, seminars, and workshops without fail.<br></br>
                            3. Students must submit their given project at the end of each session.<br></br>
                            4. Leave should be pre-intimated to the respective person (Trainer).<br></br>
                            5. Students must pay their Installment (EMI) on the mentioned date.<br></br>
                            6. If fails to pay theit Installment, Fine is applicable.<br></br>
                            7. Fees once paid will not be refunded in any circumstance.<br></br>
                            8. Course break or cancellation will not be allowed under any circumstance.<br></br>
                            9. Course completion certificate (CC) will be issued only after finishing the given projects.<br></br>
                            10.In case of an instant requirement for the certificate, Rs. 1000/- will be charged extra (within 5 days).
                        </ol>
                    </div>

                    {/* Checkbox Agreement */}
                    <div className="mt-6">
                        <div className="flex items-start gap-3">
                            <input
                                id="termsAccepted"
                                type="checkbox"
                                className="w-5 h-5 mt-1 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                checked={termsAccepted}
                                onChange={() => setTermsAccepted(!termsAccepted)}
                            />
                            <label htmlFor="termsAccepted" className="text-gray-700 text-sm">
                                <span className="font-semibold">I agree to the terms and conditions.</span>
                                <br />
                                By checking this box, I confirm that I have read, understood, and agree to be bound by the terms and conditions outlined above.
                            </label>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
                        <button
                            className="flex items-center gap-2 bg-primary-800 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded"
                            onClick={() => {
                                navigate('/admission-form')
                                setStep(step - 1);
                            }}
                        >
                            {/* <FaArrowLeftLong /> */}
                            Back
                        </button>
                        <button type='button'
                            className={`font-medium py-2 px-6 rounded transition-colors duration-300
    ${termsAccepted
                                    ? 'bg-secondary-600 hover:bg-primary-500 text-white cursor-pointer'
                                    : 'bg-gray-400 text-white cursor-not-allowed'
                                }`}
                            disabled={!termsAccepted}
                            onClick={SubmitData}
                        >
                            Submit
                        </button>

                    </div>
                </div>
            </div>
        </div>

    )
}

export default TermsAndCondition;